import React from "react";
import { useData } from "../utils/dataProvider";

export default function TarifBlock({ data, setFieldValue, values }) {
  const { setPage, doMoney, doSpMoney } = useData();

  return (
    <div className="outer-block">
      <div
        onClick={() => setFieldValue("tarif", data.ID)}
        className={`select-long-block ${
          values.tarif == data.ID ? "aktiv" : ""
        }`}
      >
        <div className="select-title">{data.name}</div>
        <div className="price">
          {doMoney(data.praemie)}
          <div style={{ fontSize: 30 }}>€</div>
        </div>
        <div style={{ marginBottom: 16 }}>Jahresbeitrag</div>
        <div className="select-vorteil">
          <img src="https://www.emover24.com/wp-content/uploads/2022/12/choosed-green.svg"></img>
          <div>Für {data.car.name}</div>
        </div>
        <div className="select-vorteil">
          <img src="https://www.emover24.com/wp-content/uploads/2022/12/choosed-green.svg"></img>
          <div>{values.privat ? "Private Nutzung" : "Gewerbliche Nutzung"}</div>
        </div>
        <div className="select-vorteil">
          <img src="https://www.emover24.com/wp-content/uploads/2022/12/choosed-green.svg"></img>
          <div>Haftpflicht-Versicherung</div>
        </div>
        {data.teilkasko && !data.vollkasko && (
          <div className="select-vorteil">
            <img src="https://www.emover24.com/wp-content/uploads/2022/12/choosed-green.svg"></img>
            <div>Teilkasko mit {doSpMoney(data.teilkasko_sb)}</div>
          </div>
        )}
        {data.vollkasko && (
          <div className="select-vorteil">
            <img src="https://www.emover24.com/wp-content/uploads/2022/12/choosed-green.svg"></img>
            <div>
              Vollkasko mit {doSpMoney(data.vollkasko_sb)} inkl. Teilkasko mit{" "}
              {doSpMoney(data.teilkasko_sb)}
            </div>
          </div>
        )}

        {values.vermietung && (
          <div className="select-vorteil">
            <img src="https://www.emover24.com/wp-content/uploads/2022/12/choosed-green.svg"></img>
            <div>Selbstfahrer-Vermietfahrzeug</div>
          </div>
        )}

        <div className="select-vorteil">
          <img src="https://www.emover24.com/wp-content/uploads/2022/12/choosed-green.svg"></img>
          <div>
            Zahlung per{" "}
            {values.zahlungsweise == "lastschrift"
              ? "Lastschrift"
              : "Überweisung"}
          </div>
        </div>
        {values.legalProtection && (
          <div className="select-vorteil">
            <img src="https://www.emover24.com/wp-content/uploads/2022/12/choosed-green.svg"></img>
            <div>
              Fahrzeug-Rechtsschutz (Jahresbeitrag: 49,- EUR, Selbstbeteiligung:
              150,- EUR)
            </div>
          </div>
        )}
        <div className="choose"></div>
      </div>
      <div className="no-kasko">
        {!data.teilkasko && !data.vollkasko && (
          <div className="no-x">
            In diesem Tarif ist keine Kaskoversicherung enthalten.
          </div>
        )}
        {data.gewerbe && !data.vermietung && (
          <div className="no-x">
            Vermietung und Kurierfahrten sind nicht versichert.
          </div>
        )}
      </div>
    </div>
  );
}
